import React from 'react';
import ReactDOM from 'react-dom';
import './global.css';
import {
    Button,
    createTheme,
    CssBaseline,
    ThemeProvider,
    StyledEngineProvider,
    adaptV4Theme,
} from '@mui/material';
import {Router} from './Router';
import {SnackbarProvider} from 'notistack';

const theme = createTheme(
    adaptV4Theme({
        overrides: {
            MuiSelect: {icon: {position: 'relative'}},
            MuiLink: {
                root: {
                    color: '#e68122',
                },
            },
            MuiIconButton: {
                root: {
                    color: 'inherit',
                },
            },
            MuiListItemIcon: {
                root: {
                    color: 'inherit',
                },
            },
            MuiToolbar: {
                root: {
                    background: '#eee',
                },
            },
            MuiTooltip: {
                tooltip: {
                    fontSize: '1.6em',
                },
            },
        },
        palette: {
            background: {
                default: '#fff',
                paper: '#eee',
            },
            text: {
                primary: '#333',
            },
            primary: {
                main: '#e68122',
            },
            secondary: {
                main: '#4bafe8',
            },
            mode: 'light',
        },
    })
);

const Snackbar: React.FC = ({children}) => {
    const notistackRef = React.createRef<any>();
    const onClickDismiss = (key: unknown) => () => {
        notistackRef.current?.closeSnackbar(key);
    };

    return (
        <SnackbarProvider
            maxSnack={3}
            ref={notistackRef}
            action={(key) => (
                <Button onClick={onClickDismiss(key)} size="small">
                    Dismiss
                </Button>
            )}
        >
            {children}
        </SnackbarProvider>
    );
};

ReactDOM.render(
    <React.StrictMode>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Snackbar>
                    <CssBaseline />
                    <Router />
                </Snackbar>
            </ThemeProvider>
        </StyledEngineProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
